import { render } from "./SyncLogs.vue?vue&type=template&id=1042a78c&scoped=true"
import script from "./SyncLogs.vue?vue&type=script&lang=js"
export * from "./SyncLogs.vue?vue&type=script&lang=js"

import "./SyncLogs.vue?vue&type=style&index=0&id=1042a78c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1042a78c"]])

export default __exports__